export default __webpack_public_path__ + "static/media/saved-item.81fb343f.svg";